import React from 'react';

function DespreAmiabila({ navigateTo }) {
  return (
    <>
      {/* Hero */}
      <section className="page-hero">
        <div className="page-hero-content">
          <div className="page-hero-icon">📋</div>
          <h1>Despre Constatarea Amiabila</h1>
          <p>
            Afla tot ce trebuie sa stii despre formularul de constatare amiabila, 
            cand il poti folosi si cum te ajuta aplicatia noastra.
          </p>
        </div>
      </section>

      {/* Content */}
      <div className="page-content">
        <div className="page-container">
          
          {/* Ce este aplicatia */}
          <div className="content-card">
            <h2>
              <span className="card-icon">🚀</span>
              Ce este aceasta aplicatie?
            </h2>
            <p>
              Aceasta aplicatie a fost creata de <strong>Auto Klasen</strong> pentru a simplifica 
              procesul de completare a formularului de constatare amiabila de accident. 
              Este un instrument <strong>100% gratuit</strong>, disponibil pentru oricine a fost 
              implicat intr-un accident auto usor.
            </p>
            <p>
              Nu ai nevoie de cont, nu salvam datele tale pe serverele noastre, 
              si poti folosi aplicatia de cate ori ai nevoie.
            </p>
          </div>

          {/* De ce am creat-o */}
          <div className="content-card">
            <h2>
              <span className="card-icon">💡</span>
              De ce am creat-o?
            </h2>
            <p>
              Multi dintre clientii nostri se confrunta cu aceleasi probleme dupa un accident:
            </p>
            <div className="info-grid-new">
              <div className="info-card-new">
                <div className="icon">😤</div>
                <h3>Aplicatia Amiabila poate fi complicata</h3>
                <p>Pentru unii clienti, aplicatia Amiabila poate fi dificil de completat pe telefon.</p>
              </div>
              <div className="info-card-new">
                <div className="icon">📄</div>
                <h3>Nu gasesti formularul printat</h3>
                <p>Cine mai are formulare in torpedou? Si cum il completezi corect fara sa gresesti?</p>
              </div>
              <div className="info-card-new">
                <div className="icon">🎨</div>
                <h3>Schita e greu de desenat</h3>
                <p>Sa desenezi accidentul pe telefon, cu degetul? O adevarata provocare.</p>
              </div>
              <div className="info-card-new">
                <div className="icon">⏱️</div>
                <h3>Pierzi timp pretios</h3>
                <p>Stai in trafic, blochezi strada, esti nervos - si trebuie sa completezi un formular.</p>
              </div>
            </div>
          </div>

          {/* Ce oferim */}
          <div className="content-card">
            <h2>
              <span className="card-icon">✨</span>
              Ce oferim noi?
            </h2>
            <div className="feature-grid">
              <div className="feature-item highlight">
                <div className="feature-icon">📝</div>
                <div>
                  <h4>Formular simplificat</h4>
                  <p>Doar campurile esentiale, organizate logic. Completezi in cateva minute.</p>
                </div>
              </div>
              <div className="feature-item highlight">
                <div className="feature-icon">🤖</div>
                <div>
                  <h4>Schita generata AI</h4>
                  <p>Descrie accidentul in cuvinte si generam schita automat.</p>
                </div>
              </div>
              <div className="feature-item highlight">
                <div className="feature-icon">📑</div>
                <div>
                  <h4>PDF Amiabila completat</h4>
                  <p>Descarci formularul Amiabila, completat cu datele tale, gata de semnat.</p>
                </div>
              </div>
              <div className="feature-item highlight">
                <div className="feature-icon">🔄</div>
                <div>
                  <h4>Poti reface oricand</h4>
                  <p>Ai gresit? Corectezi si descarci din nou. De cate ori ai nevoie.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Cand poti folosi */}
          <div className="content-card">
            <h2>
              <span className="card-icon">❓</span>
              Cand poti folosi Constatarea Amiabila?
            </h2>
            <div className="eligibility-grid">
              <div className="eligibility-box yes">
                <h3>✅ Poti folosi daca:</h3>
                <ul>
                  <li>Accidentul implica doar 2 vehicule</li>
                  <li>Nu sunt vatamari corporale grave</li>
                  <li>Ambii conducatori sunt prezenti si de acord</li>
                  <li>Vehiculele pot fi identificate</li>
                  <li>Ambele vehicule au asigurare RCA valida</li>
                </ul>
              </div>
              <div className="eligibility-box no">
                <h3>❌ NU folosi daca:</h3>
                <ul>
                  <li>Sunt persoane ranite care necesita ingrijiri</li>
                  <li>Unul dintre conducatori a parasit locul accidentului</li>
                  <li>Suspectezi ca celalalt e sub influenta alcoolului</li>
                  <li>Exista pagube la proprietati publice</li>
                  <li>Nu esti de acord cu versiunea celuilalt</li>
                </ul>
              </div>
            </div>
            <div className="warning-box">
              <p>
                <strong>⚠️ Important:</strong> In cazurile de mai sus, suna la <strong>112</strong> si asteapta Politia.
              </p>
            </div>
          </div>

          {/* De ce Autoklasen */}
          <div className="content-card">
            <h2>
              <span className="card-icon">🚗</span>
              De ce sa vii la Autoklasen?
            </h2>
            <p>
              Odata ce ai completat amiabila, urmatorul pas e deschiderea dosarului de dauna. 
              La Autoklasen, te ajutam cu tot procesul:
            </p>
            <div className="benefits-grid-new">
              <div className="benefit-card">
                <div className="icon">🚗</div>
                <h4>Masina de inlocuire</h4>
                <p>GRATUITA pe toata durata reparatiei</p>
              </div>
              <div className="benefit-card">
                <div className="icon">📋</div>
                <h4>Preluam dosarul</h4>
                <p>Nu te mai chinui cu asiguratorul</p>
              </div>
              <div className="benefit-card">
                <div className="icon">💰</div>
                <h4>Decontare directa</h4>
                <p>Nu platesti nimic din buzunar</p>
              </div>
              <div className="benefit-card">
                <div className="icon">🛡️</div>
                <h4>10 ani garantie</h4>
                <p>Pentru vopsitorie si tinichigerie</p>
              </div>
              <div className="benefit-card">
                <div className="icon">⚙️</div>
                <h4>Piese originale</h4>
                <p>Conform standardelor producatorului</p>
              </div>
              <div className="benefit-card">
                <div className="icon">📞</div>
                <h4>Suport 7-23</h4>
                <p>Echipa disponibila zilnic</p>
              </div>
            </div>
            <div className="cta-box-new">
              <h3>Ai completat amiabila?</h3>
              <p>Programeaza-te pentru constatare si lasa-ne pe noi sa ne ocupam de tot.</p>
              <a href="tel:0371719191" className="btn-cta-new">
                📞 Suna: 03 71 71 91 91
              </a>
            </div>
          </div>

          {/* FAQ */}
          <div className="content-card">
            <h2>
              <span className="card-icon">💬</span>
              Intrebari frecvente
            </h2>
            <div className="faq-grid">
              <div className="faq-item">
                <h3>Este valabil legal documentul generat?</h3>
                <p>
                  Da. Formularul generat este identic cu cel oficial european. 
                  Odata semnat de ambii conducatori, poate fi folosit pentru deschiderea dosarului de dauna.
                </p>
              </div>
              <div className="faq-item">
                <h3>Trebuie sa fiu client Autoklasen?</h3>
                <p>
                  Nu. Aplicatia este gratuita si poate fi folosita de oricine. 
                  Am creat-o pentru a ajuta toti soferii.
                </p>
              </div>
              <div className="faq-item">
                <h3>Ce fac dupa ce descarc PDF-ul?</h3>
                <p>
                  Printeaza documentul sau pastreaza-l digital. Ambii conducatori trebuie sa-l semneze. 
                  Apoi il prezinti la asigurator.
                </p>
              </div>
              <div className="faq-item">
                <h3>Se salveaza datele mele?</h3>
                <p>
                  Datele se salveaza DOAR in browserul tau (localStorage), nu pe serverele noastre. 
                  Poti sterge oricand datele din formular.
                </p>
              </div>
            </div>
          </div>

          {/* CTA Final */}
          <div className="page-cta">
            <button className="btn-primary" onClick={() => navigateTo('form')}>
              Completeaza Amiabila Acum
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </button>
          </div>

        </div>
      </div>
    </>
  );
}

export default DespreAmiabila;